import { render, staticRenderFns } from "./chart.component.vue?vue&type=template&id=a9a89f34&scoped=true"
import script from "./chart.component.vue?vue&type=script&lang=js"
export * from "./chart.component.vue?vue&type=script&lang=js"
import style0 from "./chart.component.vue?vue&type=style&index=0&id=a9a89f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a89f34",
  null
  
)

export default component.exports